import api from './api'

export const getNews = async params => {
    return await api.get("/cms/news/get", params)
}

export const getNewsDetail = async id => {
    return await api.get(`/cms/news/details/${id}`)
}

export const getHomePageInfo = async params => {
    return await api.get("/cms/index/homePageInfo", params)
}